// tokenizer和parser的工作先交给babel-parser
export { parse as default } from '@babel/parser';
